import React from 'react'
import "./App.css"
import MainComponent from "./components/MainComponent.jsx"
import WorkFlow from "./components/WorkFlow.jsx"
import Navbar from "./components/Navbar.jsx"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import ExtraPoints from './components/ExtraPoints.jsx'

const App = () => {
  return (
    <div
      style={{
        border: "2px solid black",
      }}
    >
      <div
        style={{
          background: "#e2e9ff",
          height: "100%",
          paddingBottom: "10rem",

        }}
      >
        <Router>
          <Navbar />
          <Routes>
            <Route
              exact path="/"
              element={<MainComponent />}
            />
            <Route path="/workflow" element={<WorkFlow />} />
            <Route path="/extra-points" element={<ExtraPoints />} />
            <Route path="*" element={<h1>404 Not Found</h1>} />
          </Routes>
          <ToastContainer />
        </Router>
      </div>
    </div>

  )
}

export default App
